<ngx-faceavatar [src]="src_image" dim="32" padding="10" rounded="true" class="imgprofile"></ngx-faceavatar>
